import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * This component displays a "Did you know banner" that allows user to trigger the chat-bot.
 *
 * @example
 * <smart-fix-pre-chat-banner
 *  [appliance]="'washing machine'"
 *  (openChatbot)="callback1()"
 *  (continueBooking)="callback2()"
 *  (bannerVisible)="callback3()"
 * ></smart-fix-pre-chat-banner>
 */
@Component({
  selector: 'smart-fix-pre-chat-banner',
  templateUrl: './pre-chat-banner.component.html',
  styleUrls: ['./pre-chat-banner.component.scss'],
})
export class PreChatBannerComponent implements OnInit {
  @Input() appliance!: string;
  @Output() openChatbot = new EventEmitter<void>();
  @Output() continueBooking = new EventEmitter<void>();
  @Output() bannerVisible = new EventEmitter<void>();

  ngOnInit(): void {
    this.bannerVisible.emit();
  }

  handleOpenChatbot() {
    this.openChatbot.emit();
  }

  handleContinueBooking() {
    this.continueBooking.emit();
  }
}
